import React from 'react';
import ExternalLink from './ExternalLink';
import { CustomIconLinkProps } from './components/interfaces';
import { EnvelopeIcon } from '@heroicons/react/24/solid';

/**
 * Description
 * @param {any} href
 * @param {CustomIconLinkProps} label !important -> without "mailto:"
 * @returns {any}
 */
const EmailLink = ({ href, label, icon = true }: CustomIconLinkProps & { icon?: boolean }) => {
  return <ExternalLink href={`mailto:${href}`} Icon={icon ? EnvelopeIcon : undefined} label={label} />;
};

export default EmailLink;
